import React, { useState, useEffect, useMemo, memo, useCallback } from 'react';
import {
    AppBar
    , Box
    , Toolbar
    , IconButton
    , Typography
    , Menu
    , MenuItem
    , Container
    , Avatar
    , Button
    , Tooltip
    , FormControl
    , AlertTitle
    , Select
    , ListSubheader
    , TextField
    , InputAdornment
    , List
    , ListItem
    , ListItemIcon
    , ListItemText
    , Divider
    , Drawer
    , Badge
    , LinearProgress
} from '@mui/material/';
import {
    Person as PersonIcon
    , SettingsOutlined as SettingsOutlinedIcon
    , ScheduleOutlined as ScheduleOutlinedIcon
    , VideocamOutlined as VideocamOutlinedIcon
    , PowerSettingsNewOutlined as PowerSettingsNewOutlinedIcon
    , AssessmentOutlined as AssessmentOutlinedIcon
    , ArrowForwardRounded as ArrowForwardRoundedIcon
    , ApartmentSharp as ApartmentSharpIcon
    , Search as SearchIcon
} from '@mui/icons-material/';
import CircularProgress from '@mui/material/CircularProgress';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';

//FB Push notifications
// import Notification from "../../notifications/Notification";
import { requestForToken } from "../../notifications/firebase";

//Toast notifications
import { ToastContainer, toast } from 'react-toastify';

//Global custom theme configuration
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../theme';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../actions/auth";
//UI Elements for dashboard screen
import { DashboardLogo, DashboardLogoSmall, ResponsiveTilesMenu, CustomSVGIcon } from "../../components/layout/dashboard-ui"
import { ClassNames } from '@emotion/react';
import { updateAppState, getData, getPropertyInfo } from '../../actions/appstate';

import Tile from '../Tile/';
import { TILES, TILE_GROUP_ONE, TILE_GROUP_TWO, NEW_PROPERTY_SYSTEM_SETTINGS, API_REGISTRY, ABORT_REQUEST_CONTROLLERS, APP_CACHE } from '../../app/config';
import { UPDATE_STATE } from '../../actions/types';
import { getTilesInOrder, getFromState, getLocalData, safeReference, isEmptyObj, getDataSources, abortRequestSafe, deepCopy, clearAPIRegistryData, calculatePrimaryStayRange, cleanIDB, filterValidTiles, getMatchingAirportsCodes, in_array, getSigmaReports, userReadyOnlyStatus, whichPricingModelSeasonData } from "../../app/util";
import "./styles.css";
import ReportsMenu from '../Reports/ReportsMenu';
import AlertList from './AlertList';
import AlertBell from './AlertBell';
import Prompt from '../Modal/Prompt';
import { sendLog } from '../../app/log-interface';
import ConfirmDialog from '../Modal/ConfirmDialog';
import moment from 'moment';
import { determineMeasureStates } from "../../components/Measure/measure-logic";
import { fetchDataSimple } from "../../services/data.service";
import DataService from "../../services/data.service";
import { useProductVariant } from "../../hooks/use-product-variant"
import AnalyticsReportsButton from '../Workspace/AnalyticsReportsButton';
import DynamicAlert from '../Dashboard/DynamicAlert';
import NotchContainer from "./NotchContainer"
import { EXTERNAL_REPORTS_LIST } from '../../app/config-v4-api';
import useDynamicTitle from '../../hooks/useDynamicTitle';

import { deleteAllCartItems } from '../Modal/SendRestrictionsProductModal';
import useUserLoginType from '../../hooks/useUserLoginType';

const tilesGroupOne = getTilesInOrder(TILES, TILE_GROUP_ONE);
const tilesGroupTwo = getTilesInOrder(TILES, TILE_GROUP_TWO);

const pages = [];

const userMenu = [
    {
        id: 'profileSettingsMenu', label: 'My Profile', axn: 'goToSettings',
        icon: <AccountCircleOutlinedIcon fontSize='small' sx={{ mr: 1, color: 'blue.main' }} />
    }
    , { id: 'propertySettingsMenu', label: 'Property Settings', axn: 'goToSettings', icon: <ApartmentIcon fontSize='small' sx={{ mr: 1, color: 'blue.main' }} /> }
    , { id: 'schedulerSettingsMenu', label: 'Scheduler', axn: 'goToSettings', icon: <AccessAlarmIcon fontSize='small' sx={{ mr: 1, color: 'blue.main' }} /> }
    , { id: 'videos', label: 'Videos', axn: 'gotoVideos', icon: <VideocamOutlinedIcon fontSize='small' sx={{ mr: 1, color: 'blue.main' }} /> }
    , { id: 'logout', label: 'Logout', axn: 'signOut', icon: <PowerSettingsNewOutlinedIcon fontSize='small' sx={{ mr: 1, color: 'blue.main' }} /> }
];

window.createUniqueElementId = (uniqueString) => {
    const activeTiles = [...new Set(APP_CACHE?.active_tiles || APP_CACHE?.active_tiles || [])].sort();
    const activeTilesJoined = activeTiles.join('-') || 'noactivetiles';
    const hasRestrictionTile = activeTiles.includes('restrictions');
    const isRoomType = hasRestrictionTile && APP_CACHE?.controls?.isRestrictionsRoomType === "product"
        ? 'product'
        : '';
    const fallbackUnique =
        uniqueString && uniqueString.trim() !== ""
            ? uniqueString
            : `lodgiq`;

    return `${activeTilesJoined}_${isRoomType}_${fallbackUnique}`;
};

const Header = () => {
    const { pathname } = useLocation();
    const { hasFeature } = useProductVariant()
    useDynamicTitle();
    const [selectedMenu, setSelectedMenu] = useState('');
    const handleListItemClick = (event, index) => {
        setSelectedMenu(index);
    };

    const [currentURLPath, setCurrentURLPath] = useState("");
    useEffect(() => {
        setCurrentURLPath(window.location.pathname);
    }, []);

    const [promptOpen, setPromptOpen] = useState(false);

    const [showTileDrawer, setShowTileDrawer] = useState(false);
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [loading, setLoading] = useState({ ss: false });
    const [propertyDropdownOpen, setPropertyDropdownOpen] = useState(false);

    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const { auth, app } = state;
    const { user: AuthUser, profile } = auth;

    const userLoginType = useUserLoginType();
    const usrReadyOnlyStatus = userReadyOnlyStatus(userLoginType);

    const username = (AuthUser && AuthUser.fullname) ? AuthUser.fullname : "";
    const { app_state, ui_state } = app.current_state;
    const [propertyMenu, setPropertyMenu] = useState(profile.property_details.map(property => {
        return {
            label: property.name, default: property.default, id: property.id, ea: property.ea, flights: property.flights
        }
    }))

    const [sigmaPopup, setSigmaPopup] = React.useState(false);
    const [anchorElProperties, setAnchorElProperties] = React.useState(null);
    const [selectedProperty, setSelectedProperty] = useState((propertyMenu.filter(property => property.id == profile.default_property_id))[0]);
    let [whichProperty, setWhichProperty] = useState(selectedProperty);

    let isModuleDisabled = (currentURLPath === '/settings') ? "disabled" : "";

    const [confirmOptions, setConfirmOptions] = useState({
        title: "Are You Sure You Want to Switch to ",
        descriptions: "",
        labelOk: "Change",
        labelCancel: "Cancel",
        open: false,
    });

    let propChangeToast = null;

    async function handleUserAction(action) {

        if (!action) {
            setConfirmOptions((state) => {
                return { ...state, open: false };
            })
            // handleDSChange(conFirmDialog.event, conFirmDialog.option);
        }
        if (action === 'agree') {
            setConfirmOptions((state) => {
                return { ...state, showLoader: true, open: false };
            });
            await deleteAllCartItems({ dispatch, app_state })
            dispatch(updateAppState("empty cart", { // this should be somwhere else when you change property not on menu close
                app_state: {
                    roomtype_pricing_overrides: {},
                    pricing_override_rates: {},
                    savedRestrictions: [],
                    roomTypeRestrictions: []
                },

            }));
            handleClosePropertiesMenu(whichProperty, true)
        }
        if (action === 'disagree') {
            APP_CACHE.propertySwitchStatus = '';
            APP_CACHE.property_id = app_state.property_id;
            setConfirmOptions((state) => {
                return { ...state, open: false };
            })
            // dispatch(updateAppState("disagree", { // this should be somwhere else when you change property not on menu close
            //     app_state: {
            //         //data_load:false
            //     },
            //     ui_state:{
            //         showspinner:false
            //     }

            // }));
            // handleDSChange(conFirmDialog.event, conFirmDialog.option);
        }
        if (action === 'review') {
            APP_CACHE.propertySwitchStatus = '';
            APP_CACHE.property_id = app_state.property_id;
            setConfirmOptions((state) => {
                return { ...state, open: false };
            })

            if (ui_state.active_tiles[0] === "restrictions") {
                dispatch(updateAppState("sendRestrictionsClick", { ui_state: { sendRestrictionsModalOpen: true } }));
            }
            if (ui_state.active_tiles[0] === "pricing") {
                APP_CACHE.pricingRateModalOpen = true;
                dispatch({
                    type: UPDATE_STATE, payload: { ui_state: { pricingRateModalOpen: true } }
                });
            }
        }

    }
    const navigate = useNavigate();
    useEffect(() => {
        let isSubscribed = true;

        requestForToken();
    }, []);

    useEffect(() => {
        let isSubscribed = true;
        if (!AuthUser) {
            navigate("/login");
        }
        return () => isSubscribed = false;
    }, [AuthUser])

    useEffect(() => {
        let isSubscribed = true;
        let selProperty = {}
        let p = profile.property_details.find((val, i) => {
            if (val.id === app_state.property_id) {
                selProperty = deepCopy(val);
                selProperty.label = val.name;
                setSelectedProperty(selProperty);
                return true;
            }
        });
        // profile.property_details.map(property => {
        //     if (property.id === app_state.property_id) {
        //         selProperty = property;
        //         selProperty.label = property.name;
        //     }
        // })

        return () => isSubscribed = false;
    }, [app_state.property_id])


    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = (setting) => {
        setAnchorElUser(null);
    };



    const profileMenuAxns = {
        signOut: (async () => {
            // sendLog({ category: "menu_click", action: "logout" }, { ...app.current_state }, { app_state: {}, ui_state: {} })
            await deleteAllCartItems({ dispatch, app_state })
            window.analyze.track("logout", {
                "user_email": AuthUser.user_email,
            }, { ...app.current_state }, { app_state: {}, ui_state: {} });
            dispatch(logout());
            navigate("/login");
            setAnchorElUser(null);

        }),
        goToSettings: (item) => {
            let shakeBtnsDiv = document.getElementsByClassName("top-axn-bar-1-sub");
            let shakeAlert = document.getElementsByClassName("save-changes-alert");
            const isChanged = localStorage.getItem('isChanged');
            if (isChanged == 'true') {
                if (shakeBtnsDiv.length > 0) {
                    shakeBtnsDiv[0].className += " bt-shake";
                    setTimeout(() => {
                        shakeBtnsDiv[0].className = shakeBtnsDiv[0].className.replace("bt-shake", "").trim();
                    }, 2000);
                }
                if (shakeAlert.length > 0) {
                    shakeAlert[0].className = shakeAlert[0].className.replace("display-none", "").trim();
                    setTimeout(() => {
                        shakeAlert[0].className += " display-none";
                    }, 2000);
                }
                setAnchorElUser(null);
                return;
            }
            setAnchorElUser(null);
            const settingsEventMap = {
                profileSettingsMenu:   "goto_profile_settings",
                propertySettingsMenu:  "goto_property_settings",
                schedulerSettingsMenu: "goto_scheduler_settings",
            };
            const settingsTileMap = {
                profileSettingsMenu:   "Profile Settings",
                propertySettingsMenu:  "Property Settings",
                schedulerSettingsMenu: "Scheduler Settings",
            };
            const settingsEventKey = settingsEventMap[item.id] || "goto_" + item.id;
            window.analyze.track(settingsEventKey, {
                selected_tile: settingsTileMap[item.id] || item.id,
                active_tiles: ui_state.active_tiles,
                primary_stay_range: app_state.primary_stay_range
            }, { ...app.current_state }, { app_state: {}, ui_state: { active_settings_menu: item.id, isFromHeader: true } });
            //sendLog({ category: "menu_click", action: "goto_" + item.id }, { ...app.current_state }, { app_state: {}, ui_state: { active_settings_menu: item.id, isFromHeader: true } })
            dispatch({ type: UPDATE_STATE, payload: { ui_state: { active_settings_menu: item.id, isFromHeader: true } } });
            if (pathname !== '/settings') {
                navigate("/settings");
            }

        }
    };


    const [searchText, setSearchText] = useState("");
    const allOptions = propertyMenu;
    const containsText = (text, searchText) =>
        text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
    const [selectedOption, setSelectedOption] = useState(selectedProperty);

    const displayedOptions = useMemo(
        () => allOptions.filter((option) => containsText(option.label, searchText)),
        [searchText]
    );

    const handleDailyFlash = useCallback(() => {
        // dispatch(updateAppState({ "UPDATE_STATE", ui_state: { show_flash_report: true } }));
        dispatch({
            type: UPDATE_STATE,
            payload: {
                ui_state: {
                    show_flash_report: true
                }
            }
        });

        // dispatch(
        //     updateAppState("change_flash_report", {
        //         ui_state: {
        //             show_flash_report: true,
        //         },
        //     })
        // );
    });

    const handleFullScreenLock = useCallback((title, module) => {
        dispatch({
            type: UPDATE_STATE,
            payload: {
                ui_state: { ...ui_state, fullScreenLockData: { status: true, title, module } }
            }
        });
    });

    const handleGroupPricing = useCallback(() => {
        // dispatch(
        //     updateAppState("change_group_pricing", {
        //         ui_state: {
        //             show_group_pricing: true,
        //         },
        //     }, "group_click")
        // );
        window.analyze.track('groupIQ', {
            "previous_Group_Pricing": 'No',
            "current_Group_Pricing": 'Yes',
        }, { ...app.current_state }, { app_state, ui_state });
        setTimeout(() => {
            const newUrl = window.location.origin + '/Group-IQ';
            window.open(newUrl, '_blank');
        }, 1000)
    });

    const handleGroupIQ = useCallback(() => {
        window.analyze.track('groupIQ', {
            "previous_GroupIQ": 'No',
            "current_GroupIQ": 'Yes',
        }, { ...app.current_state }, { app_state, ui_state });
        // navigate("/groupIQ");
        setTimeout(() => {
            const newUrl = window.location.origin + '/groupIQ';
            window.open(newUrl, '_blank');
        }, 1000)
    });

    const handlePropertyChangeMsg = useCallback((option) => {
        window.propertyClicked = option.label ? option.label : '';
        setSigmaPopup(true);
    });

    // AL-71: engagement-email deep links may target a hotel other than the
    // current one. The wizard asks the user first, then switches through THIS
    // component's own path (the only tested one) via this bridge. Returns false
    // when the pid isn't in the user's property menu (no access).
    useEffect(() => {
        window.__lqSwitchProperty = (pid) => {
            try {
                const option = propertyMenu.find((p) => Number(p.id) === Number(pid));
                if (!option) {
                    console.warn("AL-71 | switch bridge: pid", pid, "not in property menu",
                        propertyMenu.map((p) => p.id));
                    return false;
                }
                console.info("AL-71 | switch bridge: switching to", option.label, option.id);
                handleClosePropertiesMenu(option);
                return true;
            } catch (err) {
                console.error("AL-71 | switch bridge failed:", err);
                return false;
            }
        };
        return () => { delete window.__lqSwitchProperty; };
    });


    const handleClosePropertiesMenu = useCallback((property, fromPrompt = false) => {
        const { GetPropData } = API_REGISTRY;
        let curr_app_state = app_state;
        let curr_ui_state = ui_state;
        let app_state_clone = deepCopy(app_state);
        let ui_state_clone = deepCopy(ui_state);
        let changedMessage = "Property changed from " + app_state.property_name + " to " + property.label + "!";
        if (selectedProperty.id !== property.id) {
            let app_state = deepCopy(curr_app_state);
            let ui_state = deepCopy(curr_ui_state);
            APP_CACHE.propertySwitchStatus = 'inprogress';
            APP_CACHE.property_id = property.id;
            let apc = APP_CACHE;
            if (apc.controls) {
                apc.controls.scopeType = 'Date';
            }
            let prop_details_index = profile.property_details.findIndex(item => item.id === property.id);
            // clearAPIRegistryData();
            //Aborting in progress API calls
            let abotControllers = ABORT_REQUEST_CONTROLLERS;
            abotControllers.forEach((val, key) => {
                val.abort();
            });


            if (!usrReadyOnlyStatus && !fromPrompt && (!isEmptyObj(curr_app_state.pricing_override_rates) || !isEmptyObj(curr_app_state.roomtype_pricing_overrides))) {
                whichProperty = property;
                setWhichProperty(property)
                let descriptions = `Changing Properties Will Remove All Items From Your Pricing Cart.`;
                if ((curr_app_state?.savedRestrictions.length > 0 || curr_app_state?.roomTypeRestrictions.length > 0)) {
                    descriptions = `Changing Properties Will Remove All Items From Your Restrictions & Pricing Cart.`;
                }
                setConfirmOptions((state) => {
                    return { ...state, showLoader: false, open: true, descriptions, title: property.label };
                })
                return;
            }
            if (!usrReadyOnlyStatus && !fromPrompt && (curr_app_state?.savedRestrictions?.length > 0 || curr_app_state?.roomTypeRestrictions?.length > 0 || curr_app_state?.plrDatesToPush?.length > 0)) {
                setWhichProperty(property)
                let descriptions = "Changing Properties Will Remove All Items From Your Restrictions Cart."
                if ((!isEmptyObj(curr_app_state?.pricing_override_rates) || !isEmptyObj(curr_app_state?.roomtype_pricing_overrides))) {
                    descriptions = `Changing Properties Will Remove All Items From Your Restrictions & Pricing Cart.`;
                }
                setConfirmOptions((state) => {
                    return { ...state, open: true, descriptions, title: property.label };
                })
                return;
            }
            const measuresState = determineMeasureStates({
                active_tiles: ["otb"],
                userSelected_left_measure: "Occ",
                userSelected_right_measure: "ADR",
            });

            ui_state.left_measures_list = measuresState.leftList;
            ui_state.right_measures_list = measuresState.rightList;
            // ui_state.left_measure = "Occ";
            // ui_state.right_measure = "ADR";
            // ui_state.showspinner = true;
            ui_state.isLock = false;

            if (fromPrompt || usrReadyOnlyStatus) {
                app_state.pricing_override_rates = {};
                app_state.roomtype_pricing_overrides = {};
                app_state.savedRestrictions = [];
                app_state.roomTypeRestrictions = [];
                app_state.plrDatesToPush = [];
            }
            ui_state.table_filters.table_common.segments = [{ code: "all", title: "all", type: "allsegment" }];
            ui_state.table_filters.table_common.marketSegments = [{ code: "all", title: "all", type: "market_segments" }];
            app_state.alertShowable = true;
            app_state.property_id = property.id;
            app_state.date_range_type = 'switchingProperty';
            let ss_exists = getFromState('check_system_settings', state, property.id);
            // app_state.workspace_controls.sdlyOn = false;
            // app_state.workspace_controls.isRoomTypePricing = false;
            // app_state.workspace_controls.isRestrictionsRoomType = false;
            // app_state.primary_stay_range = { as_of_date: new moment(profile.current_property_date).startOf('day').format("YYYY-MM-DD"), date_from: new moment().startOf('month').format("YYYY-MM-DD"), date_until: new moment().endOf('month').format("YYYY-MM-DD") };
            // app_state.summary_stay_range = { as_of_date: new moment(profile.current_property_date).startOf('day').format("YYYY-MM-DD"), date_from: new moment().startOf('month').format("YYYY-MM-DD"), date_until: new moment().startOf('month').add(11, 'months').endOf('month').format("YYYY-MM-DD") };
            // app_state.as_of_date = new moment(profile.current_property_date).startOf('day').format("YYYY-MM-DD");
            //app_state.data_load = app_state.data_load ? false : true;
            //app_state.kpi_load = app_state.kpi_load ? false : true;
            ss_exists = false;
            //ui_state.active_tiles = ['otb'];

            // dispatch(updateAppState("property_change", { // this should be somwhere else when you change property not on menu close
            //     app_state: { date_range_type: 'switchingProperty' }
            //     // ui_state,
            //     // app_state: {
            //     //     ...app_state,
            //     //     kpi_load: false,
            //     //     data_load: false,
            //     //     // date_range_type: ''
            //     // },
            //     // ui_state: {
            //     //     ...ui_state,
            //     // }
            // }));

            if (!ss_exists) {

                setLoading({ ...loading, ss: true })
                getData({
                    ...curr_app_state, system_settings: true, to_pid: property.id, from_pid: selectedProperty.id, active_api: "SwitchProperty",
                })()
                    .then((res) => {
                        clearAPIRegistryData();
                        let defaultDayOfWeek = "mon,tue,wed,thu,fri,sat,sun"
                        // NEW_PROPERTY_SYSTEM_SETTINGS
                        let { system_settings, data_sources, active_source, default_source, active_ds_id, permissions } = res.data;
                        if (!system_settings.inventory_settings) {
                            console.error("CRITICAL: System settings -> Inventory settings not available");
                            system_settings = { ...NEW_PROPERTY_SYSTEM_SETTINGS, ...system_settings };
                            // delete system_settings.setup_mode;
                        }
                        setLoading({ ...loading, ss: false });
                        // setSelectedProperty(property);

                        // profile.property_details[prop_details_index].system_settings = [system_settings];
                        //Adding data sources
                        profile.property_details[prop_details_index] = { ...profile.property_details[prop_details_index], system_settings: [system_settings], active_ds_id, permissions, data_sources, active_source, default_source };
                        let localeSettings = getLocalData(auth, app_state, property.id);
                        let property_info = getPropertyInfo(profile.property_details, property.id);
                        let room_settings = [];
                        if (property_info.system_settings) {
                            room_settings = safeReference(property_info.system_settings[0], [], ["inventory_settings", "current", "room_settings"])
                        }
                        let newDataSrc = getDataSources(profile.property_details, property.id);

                        app_state.date_range_type = 'propertyChanged_' + property.id;
                        // debugger;
                        if (permissions && permissions?.pricing_model === 1) {
                            app_state.workspace_controls.isRoomTypePricing = false;
                        }
                        //app_state.historicalRange = deepCopy(app_state.primary_stay_range);
                        app_state.property_name = property_info.name;
                        //app_state.workspace_controls.segmented_view = false;
                        // app_state.workspace_controls.segmentType = 'hotel';
                        // app_state.workspace_controls.scopeType = "Date";
                        // app_state.workspace_controls.isRoomTypePricing = false;
                        // app_state.workspace_controls.sdYear = moment(app_state.as_of_date).subtract(1, 'years').format('YYYY');
                        // app_state.workspace_controls.pickUpDays = 1;
                        // app_state.workspace_controls.pickUpType = "Standard";
                        // app_state.workspace_controls.dayOfWeek = defaultDayOfWeek;
                        // app_state.workspace_controls.dba = 45;
                        // app_state.workspace_controls.isRestrictionsRoomType = (app_state.workspace_controls.isRestrictionsRoomType && permissions.restriction_d.restriction_room_type) ? permissions.restriction_d.restriction_room_type : false;
                        // app_state.workspace_controls.isRestrictionsRoomType = (app_state.workspace_controls.isRestrictionsRoomType) ? app_state.workspace_controls.isRestrictionsRoomType : false;

                        // app_state.workspace_controls.isRestrictionsRoomType = 
                        // permissions?.restriction_d?.restriction_product === true && app_state.workspace_controls.isRestrictionsRoomType === "product"
                        //     ? "product"
                        //     : permissions?.restriction_d?.restriction_house === true && app_state.workspace_controls.isRestrictionsRoomType === false
                        //     ? false
                        //     : permissions?.restriction_d?.restriction_room_type ?? false;

                        app_state.workspace_controls.isRestrictionsRoomType =
                            permissions?.restriction_d?.restriction_product === true &&
                                app_state.workspace_controls.isRestrictionsRoomType === "product" && permissions?.di_version === 4
                                ? "product"
                                : app_state.workspace_controls.isRestrictionsRoomType === true
                                    ? true
                                    : false;

                        app_state.roomTypeRestrictions = [];
                        app_state.room_settings = room_settings;
                        app_state.savedRestrictions = [];
                        app_state.active_data_src = newDataSrc.active_source;
                        app_state.market_settings = system_settings.market_settings;
                        app_state.eventList = [];
                        app_state.avgImpactData = [];
                        app_state.avgImpactDataSDLY = [];
                        app_state.eventListSDLY = [];
                        app_state.notes = [];
                        app_state.groupIQSettings = {};
                        if (system_settings.market_settings && system_settings.market_settings.length) {
                            // let sel_market_id =  app_state.selected_market.market_id;
                            let sel_market_id = (app_state?.selected_market?.market_id) ? app_state.selected_market.market_id : system_settings.market_settings[0].market_id;

                            let marketSelData = system_settings.market_settings.find(item => item.market_id === sel_market_id);
                            if (marketSelData) {
                                app_state.selected_market = marketSelData;
                            } else {
                                app_state.selected_market = system_settings.market_settings[0];
                            }
                        } else {
                            let blankData = {
                                market_id: 0,
                                value: 0,
                            }
                            app_state.selected_market = blankData;
                        }
                        // ui_state.showspinner = true;

                        // set room code in selectedRoomPricingRoomCodes
                        let defaultRoomCategory = room_settings[0];
                        defaultRoomCategory = { room_class: "All" }
                        let defaultRoomCodesList = [];
                        room_settings.forEach(room => {
                            defaultRoomCodesList.push(room.room_code)
                        })
                        if (defaultRoomCodesList.length < 1 && room_settings && room_settings.length) {
                            defaultRoomCodesList = [room_settings[0].room_code]
                        }
                        ui_state.selectedRoomPricingRoomCodes = defaultRoomCodesList;
                        ui_state.selectedRoomPricingCategory = [{ room_class: "All", room_codes: defaultRoomCodesList }]
                        ui_state.currency = localeSettings['currencyCode'];
                        ui_state.currency_symbol = localeSettings['currency_symbol'];


                        /** LRV-1035 retain top segment and  segments for pace by segment and pickup by segment */

                        const lvl1_mseg_grouping = JSON.parse(
                            JSON.stringify(system_settings.lvl1_mseg_grouping)
                        );
                        const topSegments = {};
                        lvl1_mseg_grouping.filter((item) => {
                            if (item.Transient) topSegments.Transient = item.Transient;
                            if (item.Group) topSegments.Group = item.Group;
                            if (item.Contract) topSegments.Contract = item.Contract;
                        });

                        // let selSegment = topSegments[ui_state.reports_dpbs.selectedCategory];
                        let selSegment = ui_state.reports_dpbs.selectedSegment;
                        let segList = topSegments[ui_state.reports_dpbs.selectedCategory[0]];
                        // debugger;
                        if (segList && !in_array(segList, selSegment)) {
                            selSegment = segList;
                        }
                        ui_state.reports_dpbs = { ...ui_state.reports_dpbs, selectedSegment: selSegment };

                        ui_state.table_filters.table_common.segments = [{ code: "all", title: "all", type: "allsegment" }];
                        ui_state.table_filters.table_common.marketSegments = [{ code: "all", title: "all", type: "market_segments" }];
                        ui_state.table_filters.table_reports.market_segment = [{ code: "all", title: "all", name: "all", type: "reports_segments" }];
                        ui_state.table_filters.table_reports.room_class = [{ code: "all", title: "all", name: "all", type: "room_class" }];
                        ui_state.table_filters.table_reports.room_type = [{ code: "all", title: "all", name: "all", type: "room_type" }];
                        ui_state.table_filters.table_reports.rate_plan = [{ code: "all", title: "all", name: "all", type: "rate_plan" }];
                        ui_state.table_filters.table_reports.top_market_segment =
                            [
                                {
                                    "code": "Transient",
                                    "name": "Transient",
                                    "title": "Transient",
                                    "hidden": false,
                                    "type": "top_segments"
                                },
                                {
                                    "code": "Group",
                                    "name": "Group",
                                    "title": "Group",
                                    "hidden": false,
                                    "type": "top_segments"
                                },
                                {
                                    "code": "Contract",
                                    "name": "Contract",
                                    "title": "Contract",
                                    "hidden": false,
                                    "type": "top_segments"
                                }
                            ];
                        ui_state.table_filters.table_reports.rate_plan_filter_all_selected = true;


                        //Getting updated GetPropData for current changed property
                        const { data } = res;
                        const default_property_id = Number(data.property_id);
                        const requestUri = GetPropData.uri.replace('{pid}', default_property_id);
                        dispatch({
                            type: UPDATE_STATE,
                            payload: {
                                app_state: {

                                    data_load: false,
                                    kpi_load: false,
                                    workspace_controls: { ...app_state.workspace_controls },
                                    pricingSeasons: {
                                        initial: [],
                                        updated: []
                                    },
                                },
                                ui_state: {
                                    showspinner: true,
                                    pricingSeasonsUI: {
                                        openItemId: null,
                                        changeItemId: null,
                                        discardCount: 0,
                                        globalErrorMsg: [],
                                        copyInputCount: 0,
                                        tabPanelIndex: 0,
                                        isRecalibrating: false,
                                        showRecalibratePopup: false,
                                        showRecalibratingPopup: false,
                                        recalibrationStatus: 'initial', // initial, in-progress, completed
                                    }
                                }
                            }
                        });

                        // dispatch({
                        //     type: UPDATE_STATE,
                        //     payload: {
                        //         ui_state:{currency: localeSettings['currencyCode'],
                        //         selectedRoomPricingCategory:ui_state.selectedRoomPricingCategory,
                        //         selectedRoomPricingRoomCodes:defaultRoomCodesList, 
                        //         currency_symbol: localeSettings['currency_symbol'], showspinner : true} ,
                        //     }
                        // });
                        fetchDataSimple({ api: requestUri, request: { method: 'GET' } })
                            .then((rs) => {

                                // local IDB clear
                                let apc = APP_CACHE;
                                Object.keys(apc).map((key) => {
                                    if (key.startsWith("finalized")) {
                                        delete apc[key];
                                    }
                                })
                                cleanIDB();
                                clearAPIRegistryData();
                                // end Local IDB clear 


                                APP_CACHE.propertySwitchStatus = 'done';
                                APP_CACHE.active_data_src = deepCopy(app_state.active_data_src);
                                APP_CACHE.property_id = default_property_id;
                                APP_CACHE.controls = deepCopy(app_state.workspace_controls);
                                app_state.property_id = default_property_id;
                                setSelectedProperty(property);
                                let cache_data = { data: rs, loaded: true, loading: false, reqParams: { api: requestUri, request: { method: 'GET' } } };
                                DataService.updateDataCache("GetPropData", cache_data);
                                profile.property_details[prop_details_index].product_variant = rs.pv;
                                profile.current_property_date = rs.current_date;
                                profile.current_property_time_zone = rs.timezone;
                                let defaultTile = ui_state.active_tiles[0]; //'pickup'; //rs.pv.default_tile || 'otb';
                                // let defaultTile = ui_state.active_tiles ? ui_state.active_tiles.join(',') : 'otb';

                                let pvTiles = rs?.pv?.tiles ?? [];

                                /** remove budget tile if permission is not enable for budget for any property. */
                                let updatedTiles = rs.permissions.budget === 0
                                    ? ui_state.active_tiles.filter(tile => tile !== "budget")
                                    : [...ui_state.active_tiles];
                                ui_state.active_tiles = updatedTiles;
                                /** end  */

                                let filterdMergeTiles = filterValidTiles(ui_state.active_tiles, pvTiles);
                                if (filterdMergeTiles && !filterdMergeTiles.length) {
                                    filterdMergeTiles = [defaultTile];
                                }

                                ui_state.active_tiles = filterdMergeTiles;
                                APP_CACHE.active_tiles = filterdMergeTiles;
                                // ui_state.active_tiles = (ui_state.active_tiles.length > 1) ? ui_state.active_tiles : [defaultTile];
                                // APP_CACHE.active_tiles = (ui_state.active_tiles.length > 1) ? ui_state.active_tiles : [defaultTile];

                                // LRV-1035-flight: The code below retrieves the appropriate airport codes and updates in the relevant property.
                                let propAirportCodes = rs?.airport_codes ?? [];
                                let filteredCodes = getMatchingAirportsCodes(app_state.workspace_controls.selected_airport_codes, propAirportCodes);
                                app_state.workspace_controls.selected_airport_codes = filteredCodes;
                                // LRV-1035-flight

                                // LRV-1035
                                if (!in_array(ui_state.active_tiles, ["market", "market_summary"]) && rs && rs.years && app_state.workspace_controls.sdlyOn) {

                                    let startYear = Number(moment(app_state.primary_stay_range.date_from, "YYYY-MM-DD").format("YYYY"));
                                    let endYear = rs.years[rs.years.length - 1];
                                    let sdYear = app_state.workspace_controls.sdYear
                                    if (!(startYear > sdYear && sdYear >= endYear)) {
                                        let tmpSdYear = startYear - 1;
                                        app_state.workspace_controls.sdYear = tmpSdYear;
                                        APP_CACHE.controls.sdYear = tmpSdYear;
                                        APP_CACHE.controls.sdYearsArr = rs.years;
                                    }
                                }

                                //Added this to fix SD Year dropdown options issue in Anchorage Resort by the Sea
                                if (rs && rs.years && rs.years.includes(app_state.workspace_controls.sdYear)) {
                                    APP_CACHE.controls.sdYearsArr = rs.years;
                                    app_state.workspace_controls.sdYearsArr = rs.years;
                                }

                                if (in_array(ui_state.active_tiles, ["market", "market_summary"]) && app_state.selected_market.market_id) {
                                    console.log(system_settings);
                                    let marketId = app_state.selected_market.market_id;
                                    const years = system_settings.market_settings.find(item => item.market_id === marketId)?.year;
                                    APP_CACHE.controls.sdYearsArr = years;
                                    app_state.workspace_controls.sdYearsArr = years;
                                }

                                if (in_array(ui_state.active_tiles, ["market_sell_rates"])) {
                                    app_state.workspace_controls.segmented_view = false;
                                }
                                // ui_state.showspinner = true; 
                                const tileDetails = TILES[defaultTile];
                                // if (tileDetails.chartConfig.defaultMeasures) {
                                //     const measuresState = determineMeasureStates({
                                //         active_tiles: [defaultTile],
                                //         userSelected_left_measure: TILES[defaultTile].chartConfig.defaultMeasures[0],
                                //         userSelected_right_measure: TILES[defaultTile].chartConfig.defaultMeasures[1],
                                //     });
                                //     ui_state.left_measures_list = measuresState.leftList;
                                //     ui_state.right_measures_list = measuresState.rightList;
                                //     ui_state.left_measure = TILES[defaultTile].chartConfig.defaultMeasures[0];
                                //     ui_state.right_measure = TILES[defaultTile].chartConfig.defaultMeasures[1];
                                // }
                                app_state.data_load = false;
                                app_state.kpi_load = false;
                                // app_state.as_of_date = new moment(profile.current_property_date).startOf('day').format("YYYY-MM-DD");
                                let today = new moment();
                                let date_from = today.startOf('month').format("YYYY-MM-DD");
                                let date_until = today.endOf('month').format("YYYY-MM-DD");
                                //                                let as_of_date = today.format("YYYY-MM-DD");
                                let as_of_date = new moment(profile.current_property_date).startOf('day').format("YYYY-MM-DD");

                                // app_state.historicalRange = calculatePrimaryStayRange({
                                //     date_from, date_range: {
                                //         date_until,
                                //         date_from,
                                //         as_of_date
                                //     }
                                // });
                                //{ as_of_date: new moment().startOf('day').format("YYYY-MM-DD"), date_from: new moment().startOf('month').format("YYYY-MM-DD"), date_until: new moment().endOf('month').format("YYYY-MM-DD") };
                                // app_state.rerender_app = default_property_id;

                                profile.property_details.forEach(prop => {
                                    if (prop.id === property.id) {
                                        let pricingModelNo = whichPricingModelSeasonData(prop.system_settings[0].pricing_settings.room_dow_plans, prop.permissions.pricing_model)
                                        if (pricingModelNo !== prop.permissions.pricing_model) {
                                            prop.system_settings[0].pricing_settings.room_dow_plans = [];
                                        }
                                    }
                                })

                                dispatch({ type: "SYSTEM_SETTINGS_UPDATED", payload: profile });
                                app_state.data_as_of = null; //Setting null on prop change
                                // app_state.data_as_of = (!in_array(pvTiles, ["otb"])) ? null : moment(rs.meta.ts).format('YYYY-MM-DD'); //Setting null on prop change
                                ui_state.showspinner = true;
                                app_state.workspace_controls.disableExport = false;
                                // app_state.workspace_controls.selected_airport_codes = ['JFK'];
                                // sendLog({ category: "property_menu", action: "change_poperty" }, { ...app.current_state },{
                                //     app_state,
                                //     ui_state
                                // })
                                // defaultRoomCodesList=[];
                                // room_settings.forEach(room => {
                                //     defaultRoomCodesList.push(room.room_code)
                                // })
                                // if (defaultRoomCodesList.length < 1 && room_settings && room_settings.length) {
                                //     defaultRoomCodesList = [room_settings[0].room_code]
                                // }
                                // ui_state.selectedRoomPricingRoomCodes = defaultRoomCodesList;
                                // console.log("selectedRoomPricingRoomCodes", ui_state);

                                dispatch({
                                    type: UPDATE_STATE,
                                    payload: {
                                        app_state: { ...app_state },
                                        ui_state: { ...ui_state },
                                    }
                                });


                                // // local IDB clear
                                // let apc = APP_CACHE;
                                // Object.keys(apc).map((key) => {
                                //     if (key.startsWith("finalized")) {
                                //         delete apc[key];
                                //     }
                                // })
                                // cleanIDB();
                                // clearAPIRegistryData();
                                // // end Local IDB clear 

                                // dispatch(
                                //     updateAppState("property_change", { // this should be somwhere else when you change property not on menu close
                                //         app_state,
                                //         ui_state,
                                //         // app_state: {
                                //         //     ...app_state,
                                //         //     // data_load: true, kpi_load: true
                                //         // },
                                //         // ui_state: {
                                //         //     ...ui_state
                                //         // }
                                //     })
                                // );

                                toast.dismiss();
                                toast.success(changedMessage, {
                                    position: "bottom-right"
                                });

                            }, (error) => {
                                APP_CACHE.property_id = selectedProperty.id;
                                APP_CACHE.propertySwitchStatus = 'failed';
                                console.error(error);
                            });
                    },
                        (error) => {
                            APP_CACHE.property_id = selectedProperty.id;
                            APP_CACHE.propertySwitchStatus = 'failed';
                            console.error("error in handleClosePropertiesMenu!!");
                            setLoading({ ...loading, ss: false });
                            toast.dismiss();
                            toast.error('Error! Property Changed failed, ' + error.message, {
                                position: "bottom-right"
                            });
                        })
            }
        }

    });

    const handlePropertiesChange = ((event) => {
        let v = event.target.value;
        //let t = event.currentTarget;
        //setSelectedProperty(event.target);

    })

    const handlePropertiesChangeOpen = () => {
        // top-axn-bar-1-sub bt-shake btn-active
        //save-changes-alert display-none
        const hasActiveBtn = document.querySelector('.top-axn-bar-1-sub .btn-active');
        if (hasActiveBtn) {
            document.querySelector('.top-axn-bar-1-sub').classList.add('bt-shake');
            document.querySelector('.save-changes-alert').classList.remove('display-none');
            setTimeout(() => {
                document.querySelector('.top-axn-bar-1-sub').classList.remove('bt-shake');
                document.querySelector('.save-changes-alert').classList.add('display-none');
            }, 2000);
        } else {
            setPropertyDropdownOpen(true);
        }
    }

    const [activeTile, setActiveTile] = useState(ui_state.active_tiles[0]);
    const { current_state } = useSelector(state => state.app);
    const toggleTilesDrawer = useCallback((event) => {
        setActiveTile(current_state.ui_state.active_tiles[0]);
        if (showTileDrawer) {
            setShowTileDrawer(false);
        } else {
            setShowTileDrawer(true);
        }
    });

    const handleTileClick = useCallback((event) => {
        //let states = states();
        let id = event.currentTarget.id;
        if (activeTile !== id) {
            setActiveTile(id);
            dispatch(updateAppState('tile', {
                ui_state: {
                    active_tiles: [id]
                }
            }));
        }
    });
    const anchor = 'left';
    const color = theme.palette;
    const list = useCallback(() => (
        <Box
            sx={{ width: 230, height: '100%', background: color.dark.main }}
            role="presentation"
            onClick={() => { toggleTilesDrawer() }}
            onKeyDown={() => { toggleTilesDrawer() }}
        >

            <List sx={{ padding: 0, width: '100%', display: 'block' }}>
                {tilesGroupOne.map((tile, index) => (
                    <ListItem sx={{ padding: 0, width: '100%', height: '48px', display: 'block', borderTop: '1px solid #444' }} button id={tile.id} key={index} onClick={handleTileClick} className={tile.id == activeTile ? 'active' : ''}>
                        <Tile variant='drawer' tile={tile} activeTile={activeTile} />
                    </ListItem>
                ))}
                {tilesGroupTwo.map((tile, index) => (
                    <ListItem sx={{ padding: 0, width: '100%', height: '50px', display: 'block', borderBottom: '1px solid #444' }} button id={tile.id} key={index} onClick={handleTileClick} className={tile.id == activeTile ? 'active' : ''}>
                        <Tile variant='drawer' tile={tile} activeTile={activeTile} />
                    </ListItem>
                ))}
            </List>
            <Divider />
            <ConfirmDialog {...confirmOptions} handleUserAction={handleUserAction} />
        </Box>
    ));

    function goBackToDashboard() {
        dispatch({
            type: UPDATE_STATE,
            payload: {
                app_state: {
                    data_load: true,
                    kpi_load: true,
                },
                ui_state: {
                    active_settings_menu: "",
                    showspinner: true,
                }
            },
        });

        navigate("/");
    }

    const [hovered, setHovered] = useState(false);
    const [cover, setCover] = useState(false);

    const handleMouseEnter = () => {
        if (pathname == "/analytics-reports") {
            setCover(true);
            setTimeout(() => {
                setHovered(true);
            }, 100);
        }
    };

    const handleMouseLeave = () => {
        if (pathname == "/analytics-reports") {
            setTimeout(() => {
                setHovered(false);
            }, 100);
            setTimeout(() => {
                setCover(false);
            }, 500);
        }
    };




    // let propVarient = property_details.find((propertyEle) => propertyEle.id === property_id)?.product_variant;
    // let sigmaReportsArr = propVarient?.ea_reports;
    // const exists = sigmaReportsArr.find(item => item.id.includes(ui_state.active_tiles[0]));
    const sigmaReportsIds = getSigmaReports(profile.property_details, app_state?.property_id, true);
    return (
        <ThemeProvider theme={theme}>
            <AppBar position="fixed" color='default' elevation={0} className='app-top-bar' sx={{ pt: '0px', pb: '0px', mb: 0 }}>
                {
                    // (ui_state.header_alert_msg !== "" || ui_state.showspinner === true) ? (
                    // (ui_state.header_alert_msg !== "") ? (
                    //   <LinearProgress sx={{ position: 'absolute', width: '100%' }} color='green' />
                    //   // <></>
                    // ) : (
                    //   <></>
                    // )
                }
                <Container maxWidth="xxl" className={EXTERNAL_REPORTS_LIST.includes(pathname) ? 'container-control new-tab' : 'container-control'} onMouseLeave={handleMouseLeave}>
                    {currentURLPath === "/settings" &&
                        <Box className="corner-icon top-corner">
                            <Box className="corner-icon top-corner">
                                <svg width="12" height="12" fill='#606060' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8"><path d="M0,0 H8 C3.59,0,0,3.58,0,8 V0 Z" /></svg>
                            </Box>
                        </Box>
                    }
                    <Toolbar className='tool-bar' disableGutters sx={{ minHeight: { sm: 'auto' } }}>

                        <Typography
                            id={`${ui_state.active_tiles.join("-")}__dashboard-logo`}
                            variant="h6"
                            noWrap
                            component="div"
                            className='app-logo'
                            sx={{ pt: 0, mr: 2, display: { xs: 'none', md: 'flex' } }}
                        >
                            <DashboardLogo pathname={pathname} />
                        </Typography>


                        <Typography
                            id={`${ui_state.active_tiles.join("-")}__dashboard-logo-small`}
                            variant="h6"
                            noWrap
                            component="div"
                            sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
                        >
                            <DashboardLogoSmall />

                        </Typography>
                        {
                            ui_state.header_alert_msg !== "" ? (
                                <Box sx={{ flexGrow: 1, color: "#9ed00d", ml: 21, position: "relative", width: "20%" }}>
                                    {ui_state.header_alert_msg}
                                </Box>
                            ) : (
                                <></>
                            )
                        }

                        {/* {(pathname === "/analytics-reports" && <><Box className='divider-left' onClick={goBackToDashboard} sx={{ flexGrow: 0, minHeight: "32px", cursor: "pointer" }}>
                            <CustomSVGIcon icon="icon-daily-flash" path="/assets/img/back-to-dashboard.svg" className="back-dashboard" />
                        </Box>
                        </>)} */}

                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((page) => (
                                <Button
                                    key={page}
                                    onClick={handleCloseNavMenu}
                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                >
                                    {page}
                                </Button>
                            ))}
                        </Box>

                        <Box sx={{ flexGrow: 0, display: { lg: 'none' } }}>
                            <ResponsiveTilesMenu onClick={() => { toggleTilesDrawer() }} />
                            <Drawer
                                anchor={anchor}
                                open={showTileDrawer}
                                onClose={() => { toggleTilesDrawer() }}
                            >
                                {list(anchor)}
                            </Drawer>
                        </Box>


                        {/* Analytics report Button  */}
                        {!EXTERNAL_REPORTS_LIST.includes(pathname) && <Box className='divider-left' sx={currentURLPath === '/settings' || currentURLPath === '/groupIQ' || currentURLPath === '/Group-IQ' ? { opacity: 0.4, pointerEvents: "none" } : { flexGrow: 0 }}>
                            <AnalyticsReportsButton isDisabled={currentURLPath === '/BusinessBuilder' || currentURLPath === '/settings' || currentURLPath === '/groupIQ' || currentURLPath === '/Group-IQ'} />
                        </Box>}
                        {/* Analytics report Button End  */}

                        {!EXTERNAL_REPORTS_LIST.includes(pathname) && (currentURLPath === '/settings' || currentURLPath === '/groupIQ' || currentURLPath === '/Group-IQ')
                            ?
                            // <>
                            //     {hasFeature(['group_v2'], 'features') ?
                            //         <Badge className='badgeBeta' badgeContent={'BETA'} overlap="circular" color="error">
                            //             <IconButton id={`${ui_state.active_tiles.join("-")}__daily-flash-btn`} className="icon-thin-dark icon-btn">
                            //                 <CustomSVGIcon icon="icon-daily-flash" path="/assets/img/users-three.svg" width="25" height="25" className="Group-Pricing" />
                            //             </IconButton>
                            //         </Badge>
                            //         : null}
                            //     <IconButton id={`${ui_state.active_tiles.join("-")}__daily-flash-btn`} className="icon-thin-dark icon-btn" disabled={isModuleDisabled}>
                            //         <CustomSVGIcon icon="icon-daily-flash" path="/assets/img/users-three.svg" width="25" height="25" className="Group-Pricing" />
                            //     </IconButton>
                            // </>
                            <Box className='divider-left' id={`${ui_state.active_tiles.join("-")}__group-iq-btn`} sx={{ flexGrow: 0 }}>
                                <Tooltip title="Group IQ">
                                    {/* <Badge className={ui_state.showspinner ? 'badgeBeta disabled' : 'badgeBeta'} badgeContent={'BETA'} overlap="circular" color="error"> */}
                                    <IconButton
                                        // disabled={ui_state.showspinner || isModuleDisabled ? true : false}
                                        onClick={hasFeature(['group'], 'tiles') ? handleGroupIQ : () => handleFullScreenLock('Group Pricing', 'Group Pricing')}
                                        sx={{ p: 0 }}
                                        className={`icon-btn  ${hasFeature(['group'], 'tiles') ? '' : 'lock_icon_btn'}`} >
                                        <CustomSVGIcon icon="icon-daily-flash" path="/assets/img/users-three.svg" width="25" height="25" className="Group-Pricing" />
                                    </IconButton>
                                    {/* </Badge> */}
                                </Tooltip>
                            </Box>

                            :
                            <>
                                {/* {!EXTERNAL_REPORTS_LIST.includes(pathname) && hasFeature(['group_v2'], 'features') ? */}
                                {!EXTERNAL_REPORTS_LIST.includes(pathname) ?
                                    <Box className='divider-left' id={`${ui_state.active_tiles.join("-")}__group-iq-btn`} sx={{ flexGrow: 0 }}>
                                        <Tooltip title="Group IQ">
                                            {/* <Badge className={ui_state.showspinner ? 'badgeBeta disabled' : 'badgeBeta'} badgeContent={'BETA'} overlap="circular" color="error"> */}
                                            <IconButton
                                                // disabled={ui_state.showspinner ? true : false}
                                                onClick={hasFeature(['group'], 'tiles') ? handleGroupIQ : () => handleFullScreenLock('Group Pricing', 'Group Pricing')}
                                                sx={{ p: 0 }}
                                                className={`icon-btn  ${hasFeature(['group'], 'tiles') ? '' : 'lock_icon_btn'}`} >
                                                <CustomSVGIcon icon="icon-daily-flash" path="/assets/img/users-three.svg" width="25" height="25" className="Group-Pricing" />
                                            </IconButton>
                                            {/* </Badge> */}
                                        </Tooltip>
                                    </Box>
                                    : null
                                }

                                {/* {!EXTERNAL_REPORTS_LIST.includes(pathname) && <Box id={`${ui_state.active_tiles.join("-")}__group-pricing-btn`} className='divider-left' sx={{ flexGrow: 0 }}>
                                    <Tooltip title="Group Pricing">
                                        <IconButton
                                            disabled={ui_state.showspinner || isModuleDisabled ? true : false}
                                            onClick={hasFeature(['group'], 'tiles') ? handleGroupPricing : () => handleFullScreenLock('Group Pricing', 'Group Pricing')}
                                            sx={{ p: 0 }}
                                            className={`icon-btn  ${hasFeature(['group'], 'tiles') ? '' : 'lock_icon_btn'}`} >
                                            <CustomSVGIcon icon="icon-daily-flash" path="/assets/img/users-three.svg" width="25" height="25" className="Group-Pricing" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>} */}
                            </>
                        }

                        {/* select hotel dropdown*/}
                        {currentURLPath === '/analytics-reports_x' || currentURLPath === '/groupIQ' || currentURLPath === '/Group-IQ' || currentURLPath === '/lodgiq-user-guide' ?
                            <Box className='hotel-dropdown' sx={{ pointerEvents: "none", display: "flex", gap: "6px", alignItems: "center", padding: "4px 8px" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M240,208H224V96a16,16,0,0,0-16-16H144V32a16,16,0,0,0-24.88-13.32L39.12,72A16,16,0,0,0,32,85.34V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM208,96V208H144V96ZM48,85.34,128,32V208H48ZM112,112v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm-32,0v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm0,56v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm32,0v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Z"></path></svg>
                                <div style={{ color: "#fff" }}>{selectedProperty.name}</div>
                            </Box>
                            :
                            sessionStorage.getItem('sigma_report_id') === 'portfolio_ea' && currentURLPath === '/analytics-reports' ? <></> :
                                <Box className='hotel-dropdown' sx={{ flexGrow: 0 }}>
                                    <Tooltip title="Properties">
                                        <svg onClick={() => setPropertyDropdownOpen(true)} className="hotel-dropdown-icon-header" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M240,208H224V96a16,16,0,0,0-16-16H144V32a16,16,0,0,0-24.88-13.32L39.12,72A16,16,0,0,0,32,85.34V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM208,96V208H144V96ZM48,85.34,128,32V208H48ZM112,112v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm-32,0v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm0,56v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm32,0v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Z"></path></svg>
                                    </Tooltip>

                                    <FormControl variant="standard">
                                        <Select

                                            // Disables auto focus on MenuItems and allows TextField to be in focus
                                            open={propertyDropdownOpen}
                                            onOpen={() => handlePropertiesChangeOpen()}
                                            onClose={() => {
                                                setPropertyDropdownOpen(false);
                                                setSearchText("");
                                            }}
                                            MenuProps={{ autoFocus: false }}
                                            labelId="search-select-label"
                                            id="search-select"
                                            className='property-menu'
                                            value={selectedProperty.id}
                                            onChange={handlePropertiesChange}
                                            //onClose={() => setSearchText("")}
                                            // This prevents rendering empty string in Select's value
                                            // if search text would exclude currently selected option.

                                            renderValue={() => (<>{selectedProperty.label} {loading.ss && <CircularProgress size={18} sx={{ position: 'absolute', right: "3px", top: "5px" }} color='green' />}</>)}
                                            inputProps={{ 'aria-label': 'Without label' }}

                                            sx={[{ width: { xs: 100, sm: 140 }, color: '#fff', mr: 0, mt: 1.5, ml: 0 },
                                            {
                                                '&::before': {
                                                    borderBottom: 'none'
                                                },
                                                '&::after': {
                                                    borderBottom: 'none'
                                                },
                                                '& .MuiSelect-icon': {
                                                    color: 'white.main'
                                                },

                                                '&.MuiInput-root:hover:before': {
                                                    border: 'none'
                                                },
                                                '&.MuiInput-root .MuiSelect-select': {
                                                    background: 'none'
                                                },
                                                '&.Mui-disabled': {
                                                    opacity: '0.4'
                                                }
                                            }
                                            ]}
                                        >
                                            {/* TextField is put into ListSubheader so that it doesn't
                                            act as a selectable item in the menu
                                            i.e. we can click the TextField without triggering any selection.*/}
                                            <ListSubheader className='dropdown-search-box'>
                                                <TextField
                                                    size="small"
                                                    // Autofocus on textfield
                                                    autoFocus
                                                    placeholder="Type to search..."
                                                    fullWidth
                                                    autoComplete="off"
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key !== "Escape") {
                                                            // Prevents autoselecting item while typing (default Select behaviour)
                                                            e.stopPropagation();
                                                        }
                                                    }}
                                                />
                                            </ListSubheader>

                                            {/* {displayedOptions.map((option, i) => (

                                            <MenuItem key={i} title={option.label + '-' + option.id} value={option.id} onClick={() => handleClosePropertiesMenu(option)}>
                                                {option.label}
                                            </MenuItem>
                                        ))} */}
                                            {displayedOptions
                                                .slice()
                                                .sort((a, b) => a.label.localeCompare(b.label))
                                                .map((option, i) => (
                                                    // <MenuItem className={option.ea ? 'txt-bold' : ''} key={i} title={option.label + '-' + option.id} value={option.id} onClick={() => handleClosePropertiesMenu(option)}>
                                                    //     {option.label}
                                                    // </MenuItem>
                                                    <MenuItem
                                                        id={`propertymenu__${String(option.label).trim().replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '')}`}
                                                        className={option.ea ? 'option-text analytics' : 'option-text'}
                                                        key={i}
                                                        title={option.label + '-' + option.id}
                                                        value={option.id}
                                                        onClick={() => {
                                                            // if (!option.ea && app_state.workspace_controls.sigma_report_id === 'otb_ea' && pathname === "/analytics-reports") {
                                                            //     handlePropertyChangeMsg(option);
                                                            // }else if (!option.flights && app_state.workspace_controls.sigma_report_id === 'flight_ea' && pathname === "/analytics-reports") {
                                                            //     handlePropertyChangeMsg(option);
                                                            // } else {
                                                            //     handleClosePropertiesMenu(option);
                                                            // }
                                                            const isBiEnable = sigmaReportsIds.includes(app_state.workspace_controls.sigma_report_id);
                                                            const isFlightEa = app_state.workspace_controls.sigma_report_id === 'flight_ea';
                                                            const isOnReportsPage = EXTERNAL_REPORTS_LIST.includes(pathname);
                                                            if (isOnReportsPage && (
                                                                (isBiEnable && !option.ea) ||
                                                                (isFlightEa && !option.flights)
                                                            )) {
                                                                handlePropertyChangeMsg(option);
                                                            } else {
                                                                handleClosePropertiesMenu(option);
                                                            }
                                                        }}
                                                    >
                                                        <Box sx={{ display: "grid", gridTemplateColumns: "20px auto", gap: "6px" }}>
                                                            <div>
                                                                {!option.ea ? null :
                                                                    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g clip-path="url(#clip0_1270_4391)">
                                                                            <path d="M9.18931 8.35988C9.08677 8.35988 8.98423 8.31988 8.91324 8.23988C8.75548 8.08788 8.75548 7.83188 8.91324 7.67188L11.4137 5.13588C11.4847 5.06388 11.5872 5.01588 11.6898 5.01588C11.7923 5.01588 11.8948 5.05588 11.9658 5.13588L13.1017 6.28788L15.3576 3.99988C15.5153 3.83988 15.7599 3.83988 15.9176 3.99988C16.0754 4.15988 16.0754 4.40788 15.9176 4.56788L13.3856 7.13588C13.2279 7.29588 12.9834 7.29588 12.8256 7.13588L11.6898 5.98388L9.47327 8.23988C9.3944 8.31988 9.29185 8.35988 9.1972 8.35988H9.18931Z" fill="#606060" />
                                                                            <path d="M5.7108 0.399902V4.1359H0.394409V1.8959C0.394409 1.0639 1.0491 0.399902 1.86154 0.399902H5.7108Z" fill="#F8F9FA" />
                                                                            <path d="M5.7108 4.13599H0.394409V7.86399H5.7108V4.13599Z" fill="#EBEBEB" />
                                                                            <path d="M5.7108 7.86401V11.6H1.86154C1.0491 11.6 0.394409 10.936 0.394409 10.104V7.86401H5.7108Z" fill="#B2B2B2" />
                                                                            <path d="M5.71078 0H1.86152C0.836109 0 0 0.848 0 1.896V10.104C0 11.152 0.836109 12 1.86152 12H5.71078C5.93164 12 6.10517 11.824 6.10517 11.6V0.4C6.10517 0.176 5.93164 0 5.71078 0ZM0.788782 4.536H5.31639V7.464H0.788782V4.536ZM0.788782 1.896C0.788782 1.288 1.26994 0.8 1.86152 0.8H5.31639V3.736H0.788782V1.896ZM5.31639 11.2H1.86152C1.26994 11.2 0.788782 10.712 0.788782 10.104V8.264H5.31639V11.2Z" fill="#606060" />
                                                                            <path d="M16.1385 12H6.97288C6.75202 12 6.57849 11.824 6.57849 11.6V0.4C6.57849 0.176 6.75202 0 6.97288 0H16.1385C17.1639 0 18.0079 0.848 18.0079 1.896V10.112C18.0079 11.152 17.1718 12.008 16.1385 12.008V12ZM7.36727 11.2H16.1385C16.7301 11.2 17.2192 10.712 17.2192 10.104V1.896C17.2192 1.296 16.738 0.8 16.1385 0.8H7.36727V11.2Z" fill="#606060" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_1270_4391">
                                                                                <rect width="18" height="12" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                }
                                                            </div>
                                                            <div>{option.label}</div>
                                                        </Box>
                                                    </MenuItem>
                                                ))
                                            }


                                        </Select>
                                    </FormControl>
                                </Box>
                        }


                        <Box sx={{ flexGrow: 0, display: { lg: 'none' } }}>
                            <ResponsiveTilesMenu onClick={() => { toggleTilesDrawer() }} />
                            <Drawer
                                anchor={anchor}
                                open={showTileDrawer}
                                onClose={() => { toggleTilesDrawer() }}
                            >
                                {list(anchor)}
                            </Drawer>
                        </Box>

                        {currentURLPath === '/settings_xx' || currentURLPath === '/groupIQxx'
                            ?
                            <IconButton id={`${ui_state.active_tiles.join("-")}__daily-flash-btn`} className="icon-thin-dark icon-btn">
                                <CustomSVGIcon icon="icon-daily-flash" path="/assets/img/business-intelligence.svg" width="25" height="25" className="daily-flash disabled" />
                            </IconButton>
                            :

                            (!EXTERNAL_REPORTS_LIST.includes(pathname) && <Box id={`${ui_state.active_tiles.join("-")}__daily-flash-btn`} className='divider-left' sx={{ flexGrow: 0 }}>
                                <Tooltip title="Daily Flash">
                                    <IconButton
                                        disabled={isModuleDisabled}
                                        onClick={hasFeature(['daily_flash', 'daily_flash_mark'], 'tiles', 'some') ? handleDailyFlash : () => handleFullScreenLock('Daily Flash', 'Daily Flash')}
                                        sx={{ p: 0 }}
                                        className={`icon-btn ${hasFeature(['daily_flash', 'daily_flash_mark'], 'tiles', 'some') ? '' : 'lock_icon_btn'}`}>
                                        <CustomSVGIcon icon="icon-daily-flash" path="/assets/img/business-intelligence.svg" width="25" height="25" className="daily-flash" />
                                    </IconButton>
                                </Tooltip>
                            </Box>)
                        }

                        {!EXTERNAL_REPORTS_LIST.includes(pathname) && <Box id={`${ui_state.active_tiles.join("-")}__reports-menu`} className='divider-left' sx={{ flexGrow: 0 }}>
                            <ReportsMenu disabled={isModuleDisabled} />
                        </Box>}


                        {/* Notification AlertBell */}
                        {!EXTERNAL_REPORTS_LIST.includes(pathname) &&
                            <Box id={`${ui_state.active_tiles.join("-")}__alert-bell`} className='divider-left' sx={{ flexGrow: 0, pt: 0.5, pb: 0.5 }}>
                                <AlertBell disabled={isModuleDisabled} />
                            </Box>}

                        {/* Profile Img Icon */}

                        <Box id={`${ui_state.active_tiles.join("-")}__profile-menu-btn`} className={sessionStorage.getItem('sigma_report_id') !== 'portfolio_ea' ? "divider-left2" : ""} sx={{ flexGrow: 0 }}>
                            <Tooltip title="Profile & Settings">
                                <IconButton className='icon-btn' onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    {profile.profile_image.indexOf('person.png') === -1 && <Avatar className='profileIcon' sx={{ width: 30, height: 30 }} alt={AuthUser.fullname} src={AuthUser.profile_image_url} />}
                                    {profile.profile_image.indexOf('person.png') !== -1 && <Avatar className='profileIcon' sx={{ width: 30, height: 30, textTransform: "uppercase", backgroundColor: "#01A4EF" }} alt={AuthUser.fullname}><strong>{AuthUser.fullname[0]}</strong></Avatar>}
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '20px', zIndex: 9992, }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                                PaperProps={{

                                    elevation: 0,
                                    sx: {
                                        overflow: 'visible',
                                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                        mt: 1.5,
                                        '& .MuiAvatar-root': {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                        },
                                        '&:before': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: 'background.paper',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            zIndex: 0,
                                        },
                                    },
                                }}
                            >
                                {
                                    (currentURLPath === '/lodgiq-user-guide' ? userMenu.filter((item) => item.id === 'logout') : userMenu).map((item, index) => (
                                        <MenuItem
                                            id={`usermenu__${String(item.label).toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')}`}
                                            onClick={() => profileMenuAxns[item.axn](item, Event)} key={index} selected={ui_state.active_settings_menu === item.id}>
                                            {item.icon}  {item.label}
                                        </MenuItem>
                                    ))
                                }


                            </Menu>
                        </Box>



                    </Toolbar>

                    {EXTERNAL_REPORTS_LIST.includes(pathname) && !'/groupIQ'.includes(pathname) && !'/Group-IQ'.includes(pathname) && pathname !== '/lodgiq-user-guide' &&
                        <NotchContainer
                            hovered={hovered}
                            cover={cover}
                            handleMouseEnter={handleMouseEnter}
                            handleMouseLeave={handleMouseLeave}
                        />
                    }
                </Container>

                {/* <Prompt isOpen={promptOpen} options={{title:"Switching properties will clear all items in your pricing cart", 
                prompt:"Would you like to continue?"}} 
                handleClose={(response)=>{
                    if(response === true){
                        dispatch(updateAppState("empty cart", { // this should be somwhere else when you change property not on menu close
                            app_state: {
                                roomtype_pricing_overrides: {},
                                pricing_override_rates: {}
                            },
                           
                        }));
                        handleClosePropertiesMenu(whichProperty, true)
                    }
                    setPromptOpen(false);
                }} /> */}
                <ConfirmDialog {...confirmOptions} handleUserAction={handleUserAction} />
                <DynamicAlert reportId={app_state.workspace_controls.sigma_report_id} purpose="property-change" username={username} handleClose={() => { setSigmaPopup(false) }} showAlert={sigmaPopup} message="Analytics Report is not enable for this property. Please contact to Administrator." />

            </AppBar>
            <ToastContainer />
        </ThemeProvider>
    );
};
export default memo(Header);